import Axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { apiURL } from "config/api";
import Cookies from "js-cookie";

const axios = Axios.create({
  baseURL: apiURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Accept-Language": window.localStorage.getItem("local-lang"),
  },
  withCredentials: true,
  validateStatus: (status) => status >= 400,
});

const onRequest = (config: InternalAxiosRequestConfig<any>): InternalAxiosRequestConfig<any> => {
  const acToken = Cookies.get("access_token");
  config.validateStatus = (_) => true;
  config.headers["Authorization"] = `Bearer ${acToken}`;
  axios.defaults.headers.common["Authorization"] = `Bearer ${acToken}`;
  return config;
};

const onRequestError = (error: AxiosError<any>): Promise<AxiosError<any>> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse<any>): AxiosResponse<any> => {
  return response;
};

const onResponseError = async (error: AxiosError<any>) => {
  if (error.response) {
    if (error.response.status === 403 && error.response.data) {
      return Promise.resolve(error.response.data);
    }
    return Promise.reject(error);
  }
  return Promise.reject(error);
};

axios.interceptors.request.use(onRequest, onRequestError);
axios.interceptors.response.use(onResponse, onResponseError);

export { AxiosError };
export const thrownResponse = (res: any): never => {
  if (res.status === 401) {
    Cookies.remove("access_token");
    localStorage.clear();
    const url = window.location.origin;
    window.location.replace(`${url}/`);
  }
  throw new Error(res?.data?.message);
};

export default axios;
